<template>
    <!--    <v-select dense class="text-right d-flex" style="width: 200px; float: right" v-model="$language.current" :items="$language.available" item-text="available"></v-select>-->
    <v-btn-toggle v-model="$language.current"
                  :class="{'text-center d-flex justify-center': $vuetify.breakpoint.smAndDown, 'absolute right-50': $vuetify.breakpoint.mdAndUp}"
                  class=""
                  dense @change="persistCurrentLanguage()">
        <v-btn v-for="(language, key) in $language.available" :value="key" dense>
            <FlagIconCustom :iso="key.split('_')[1]" :squared="false"/>
        </v-btn>
    </v-btn-toggle>
    <!--    <select name="language" v-model="$language.current">
            <option v-for="(language, key) in $language.available" :value="key">{{ language }}</option>
        </select> -->


    <!--        <select name="language" v-model="$language.current" class="text-right d-flex" style="float: right">-->
    <!--            <option v-for="(language, key) in $language.available" :value="key">{{ language }}</option>-->
    <!--        </select>-->

</template>
<script>

import Vue from "vue";
// DISABLED: Using custom flag component instead to avoid loading all 259 flags
// import FlagIcon from 'vue-flag-icon'
import MixinGenericLocalStorage from "@/mixins/MixinGenericLocalStorage";
// Import custom flag-icons CSS with only European languages (instead of all 259 flags)
import '@/assets/css/flag-icons-custom.css'
import FlagIconCustom from '@/components/FlagIconCustom.vue'

// DISABLED: Using custom flag component instead
// Vue.use(FlagIcon)

export default {
    components: {
        FlagIconCustom
    },
    mixins: [MixinGenericLocalStorage],
    async mounted() {

        let self = this;

        try {

            if (self.genericLocalStorageHasItem('language')) {
                let l = await self.genericLocalStorageGetItem('language');
                if (l && self.$language && self.$language.available) {
                    self.$language.current = l;
                }
            }
            
        } catch (e) {
            console.error(e);
        }

    },
    methods: {
        persistCurrentLanguage() {
            let self = this;
            if (self.$language && self.$language.current) {
                self.genericLocalStorageSetItem('language', self.$language.current);
            }
        }
    }
}

</script>

<style scoped>
.flag-size {
    font-size: 18px;
}
</style>